import { RouteObject } from 'react-router-dom';
import { RoutesEnum } from '~/constants/enums';
import PersonalInfo from '~/modules/myAccount/pages/PersonalInfo';
import PersonalInfoDetails from '~/modules/myAccount/pages/PersonalInfo/PersonalInfoDetails';

const routes: RouteObject[] = [
  {
    path: RoutesEnum.PERSONAL_INFO,
    children: [
      {
        index: true,
        element: <PersonalInfo />,
      },
      {
        path: RoutesEnum.UPDATE,
        element: <PersonalInfoDetails />,
      },
    ],
  },
];
export default routes;
